module.exports = {
      id: "sort-usage",
      viewBox: "0 0 6 8",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#sort",
      toString: function () {
        return this.url;
      }
    }